// import { useEffect, useState, useRef } from "react";

// const Chatbot = () => {
//   const [open, setOpen] = useState(false);
//   const [chat, setChat] = useState([]);
//   const [input, setInput] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showInput, setShowInput] = useState(false);
//   const [showCloseConfirm, setShowCloseConfirm] = useState(false);
//   const [windowState, setWindowState] = useState("default");
//   const [showInitialNotification, setShowInitialNotification] = useState(false);
//   const [showMinimizeNotification, setShowMinimizeNotification] = useState(false);
//   const [hasNewReply, setHasNewReply] = useState(false);
//   const modalRef = useRef(null);

//   // Initial opening animation
//   useEffect(() => {
//     const notificationTimer = setTimeout(() => setShowInitialNotification(true), 2000);
//     const openTimer = setTimeout(() => {
//       setShowInitialNotification(false);
//       setOpen(true);
//     }, 3500);
//     return () => {
//       clearTimeout(notificationTimer);
//       clearTimeout(openTimer);
//     };
//   }, []);

//   // Reset chat on open/close
//   useEffect(() => {
//     if (open) {
//       setChat([
//       {
//         from: "bot",
//         text: "👋 Hi there! I'm Vinodh Kumar's AI assistant. Ask me about my experience, cloud security work, projects, certifications, or technical skills!",
//       },
//     ]);
//       setShowInput(true);
//       setShowCloseConfirm(false);
//       setWindowState("default");
//       setHasNewReply(false);
//     } else {
//       setShowInput(false);
//       setInput("");
//       setLoading(false);
//       setShowCloseConfirm(false);
//       setWindowState("default");
//       setShowMinimizeNotification(false);
//     }
//   }, [open]);

//   useEffect(() => {
//     if (showCloseConfirm && modalRef.current) {
//       modalRef.current.focus();
//     }
//   }, [showCloseConfirm]);

//   useEffect(() => {
//     if (windowState === "minimized" && chat.some((msg) => msg.from === "user")) {
//       setShowMinimizeNotification(true);
//       const timer = setTimeout(() => setShowMinimizeNotification(false), 3000);
//       return () => clearTimeout(timer);
//     } else {
//       setShowMinimizeNotification(false);
//     }
//   }, [windowState, chat]);

//   // Chat controls
//   const openChat = () => { setOpen(true); setHasNewReply(false); };
//   const requestCloseChat = () => {
//     if (chat.length === 1 && chat[0].from === "bot") confirmClose();
//     else setShowCloseConfirm(true);
//   };
//   const cancelClose = () => setShowCloseConfirm(false);
//   const confirmClose = () => { setOpen(false); setChat([]); setShowCloseConfirm(false); };
//   const toggleWindowState = () => {
//     if (windowState === "minimized") setWindowState("default");
//     else if (windowState === "default") setWindowState("maximized");
//     else setWindowState("minimized");
//     setHasNewReply(false);
//   };

//   // Send question to backend
//   const sendQuestion = async (question) => {
//     if (!question.trim()) return;

//     setChat((prev) => [...prev, { from: "user", text: question }]);
//     setInput("");
//     setLoading(true);
//     setHasNewReply(false);

//     try {
//       const response = await fetch("https://portfolio-chatbot-1-7u5i.onrender.com/api/chatbot", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ question }),
//       });
//       if (!response.ok) throw new Error("Server error");

//       const data = await response.json();
//       setChat((prev) => [...prev, { from: "bot", text: data.reply || "Sorry, I couldn't find an answer." }]);
//       if (windowState === "minimized") setHasNewReply(true);
//     } catch (error) {
//       console.error("Chatbot API error:", error);
//       setChat((prev) => [...prev, { from: "bot", text: "⚠️ Something went wrong connecting to the assistant." }]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClear = () => {
//     setChat([{ from: "bot", text: "👋 How can I assist you about Vinodh?" }]);
//     setInput("");
//     setShowInput(true);
//     setShowCloseConfirm(false);
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !loading && input.trim()) {
//       e.preventDefault();
//       sendQuestion(input);
//     }
//   };

//   return (
//     <>
//       {/* Initial notification */}
//       {showInitialNotification && (
//         <div className="fixed bottom-28 right-4 bg-gradient-to-r from-cyan-500/80 to-indigo-500/80 text-white rounded-lg px-4 py-2 shadow-lg z-50 animate-fade-in-up">
//           Chatbot opening soon...
//         </div>
//       )}

//       {/* Minimize notification */}
//       {showMinimizeNotification && (
//         <div className="fixed bottom-28 right-4 bg-gradient-to-r from-cyan-500/80 to-indigo-500/80 text-white rounded-lg px-4 py-2 shadow-lg z-50 animate-fade-in-up">
//           Chat minimized! Click 💬 to continue.
//         </div>
//       )}

//       {/* New reply notification */}
//       {hasNewReply && windowState === "minimized" && (
//         <div className="fixed bottom-36 right-4 bg-gradient-to-r from-green-500/80 to-blue-600/80 text-white rounded-lg px-4 py-2 shadow-lg z-50 animate-fade-in-up">
//           1 new reply received. Click 💬 to view.
//         </div>
//       )}

//       {/* Floating chat button */}
//       <button
//         onClick={open ? requestCloseChat : openChat}
//         className={`fixed bottom-6 right-4 w-16 h-16 rounded-full flex items-center justify-center text-2xl z-50 shadow-lg transition-transform duration-300
//           ${hasNewReply ? "animate-bounce ring-2 ring-cyan-400 bg-gradient-to-br from-cyan-400 to-indigo-600" 
//                         : "bg-gradient-to-br from-cyan-400 to-indigo-600"}`}
//         aria-label="Toggle Chatbot"
//       >
//         💬
//         {hasNewReply && <span className="absolute top-1 right-1 w-3.5 h-3.5 rounded-full bg-red-600 border-2 border-white" />}
//       </button>

//       {/* Chat window */}
//       {open && (
//         <div
//           className={`fixed bg-gradient-to-br from-gray-900/80 to-gray-800/80 backdrop-blur-2xl text-white shadow-2xl border border-white/20 transition-all duration-500 ease-in-out flex flex-col z-50 animate-fade-in-slide-up
//             ${windowState === "minimized"
//               ? "bottom-24 right-4 w-20 h-16 rounded-full"
//               : windowState === "maximized"
//               ? "inset-2 max-w-[95vw] max-h-[95vh] rounded-2xl"
//               : "bottom-12 right-4 max-w-[90vw] w-full sm:w-[400px] h-[70vh] rounded-2xl"
//             }`}
//         >
//           {/* Header */}
//           <div className="p-3 border-b border-white/10 flex justify-between items-center font-semibold text-lg bg-gradient-to-r from-cyan-900/50 to-indigo-900/50 backdrop-blur-md rounded-t-2xl">
//             Vinodh Kumar • AI Assistant
//             <div className="flex gap-2">
//               <button onClick={toggleWindowState} className="text-gray-200 hover:text-white" disabled={showCloseConfirm}>
//                 {windowState === "maximized" ? "🗕" : windowState === "minimized" ? "🗖" : "🗖"}
//               </button>
//               <button onClick={requestCloseChat} className="text-gray-200 hover:text-white" disabled={showCloseConfirm}>
//                 ✕
//               </button>
//             </div>
//           </div>

//           {/* Hire Me button */}
//           {windowState !== "minimized" && (
//             <div className="p-3 border-b border-white/10">
//               <button
//                 onClick={() => window.open("mailto:vinodhkumar142002@gmail.com")}
//                 className="w-full bg-gradient-to-r from-cyan-500 to-indigo-500 hover:scale-105 hover:brightness-125 rounded-lg px-4 py-2 text-center font-semibold text-white shadow-md transition-all"
//               >
//                 Hire Me
//               </button>
//             </div>
//           )}

//           {/* Chat area */}
//           {windowState !== "minimized" && (
//             <div className={`flex-1 p-3 space-y-3 overflow-y-auto relative ${showCloseConfirm ? 'overflow-hidden' : 'overflow-y-auto'}`}>
//               {chat.map((msg, idx) => (
//                 <div
//                   key={idx}
//                   className={`p-3 rounded-xl shadow-sm backdrop-blur-sm border border-white/10 ${
//                     msg.from === "user"
//                       ? "bg-gradient-to-r from-cyan-500/60 to-indigo-500/60 text-white self-end ml-auto max-w-[80%]"
//                       : "bg-gradient-to-r from-gray-700/60 to-gray-600/60 text-white self-start mr-auto max-w-[80%]"
//                   }`}
//                 >
//                   {msg.text}
//                 </div>
//               ))}
//               {loading && <div className="text-sm text-center text-gray-200 animate-pulse">Typing...</div>}
//             </div>
//           )}

//           {/* Input */}
//           {windowState !== "minimized" && showInput && !showCloseConfirm && (
//             <div className="p-2 border-t border-white/10 flex gap-2 bg-gray-900/70 backdrop-blur-sm rounded-b-2xl">
//               <input
//                 type="text"
//                 className="flex-1 rounded-lg px-3 py-2 bg-gray-800/50 text-white placeholder-gray-300 border border-white/20 focus:ring-2 focus:ring-cyan-400 outline-none"
//                 placeholder="Ask about experience, cloud security, projects..."
//                 value={input}
//                 onChange={(e) => setInput(e.target.value)}
//                 onKeyDown={handleKeyDown}
//                 disabled={loading}
//               />
//               <button
//                 onClick={() => sendQuestion(input)}
//                 className="bg-gradient-to-br from-cyan-500 to-indigo-500 px-4 py-2 rounded-lg text-white font-semibold shadow-md hover:scale-105 hover:brightness-110 disabled:opacity-50 transition-all"
//                 disabled={loading || !input.trim()}
//               >
//                 Send
//               </button>
//             </div>
//           )}

//           {/* Clear chat */}
//           {windowState !== "minimized" && !showCloseConfirm && (
//             <div className="flex justify-between px-4 py-2 text-sm border-t border-white/10 bg-gray-900/70 text-gray-200 rounded-b-2xl">
//               <button onClick={handleClear} className="hover:text-white">🧹 Clear</button>
//             </div>
//           )}

//           {/* Close confirmation modal */}
//           {showCloseConfirm && (
//             <div
//               ref={modalRef}
//               tabIndex={-1}
//               className="absolute inset-0 bg-black/70 backdrop-blur-md flex flex-col items-center justify-center rounded-2xl p-6 z-50"
//               role="dialog"
//               aria-modal="true"
//               aria-labelledby="confirm-close-title"
//             >
//               <p id="confirm-close-title" className="mb-5 text-center text-lg font-semibold text-white">
//                 Are you sure you want to close the chat? <br /> Your questions and answers will be lost.
//               </p>
//               <div className="flex gap-4">
//                 <button onClick={confirmClose} className="px-5 py-2.5 bg-gradient-to-r from-red-500 to-red-700 rounded-lg hover:brightness-125 font-semibold text-white shadow-md">
//                   Yes, Close
//                 </button>
//                 <button onClick={cancelClose} className="px-5 py-2.5 bg-gradient-to-r from-gray-600 to-gray-700 rounded-lg hover:brightness-125 font-semibold text-white shadow-md">
//                   Cancel
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default Chatbot;

//-------------------------------

// import { useEffect, useState, useRef } from "react";

// const Chatbot = () => {
//   const [open, setOpen] = useState(false);
//   const [chat, setChat] = useState([]);
//   const [input, setInput] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showInput, setShowInput] = useState(false);
//   const [showCloseConfirm, setShowCloseConfirm] = useState(false);
//   const [windowState, setWindowState] = useState("default");
//   const [showInitialNotification, setShowInitialNotification] = useState(false);
//   const [showMinimizeNotification, setShowMinimizeNotification] = useState(false);
//   const [hasNewReply, setHasNewReply] = useState(false);

//   const modalRef = useRef(null);
//   const chatEndRef = useRef(null);

//   /* ---------------- INITIAL OPEN ANIMATION ---------------- */

//   useEffect(() => {
//     const notificationTimer = setTimeout(() => setShowInitialNotification(true), 2000);

//     const openTimer = setTimeout(() => {
//       setShowInitialNotification(false);
//       setOpen(true);
//     }, 3500);

//     return () => {
//       clearTimeout(notificationTimer);
//       clearTimeout(openTimer);
//     };
//   }, []);

//   /* ---------------- RESET CHAT ---------------- */

//   useEffect(() => {
//     if (open) {
//       setChat([
//         {
//           from: "bot",
//           text:
//             "👋 Hi there! I'm Vinodh Kumar's AI assistant.\n\nYou can ask me about:\n• Cloud Security (AWS, Prisma Cloud)\n• Experience at Deloitte\n• Projects and Certifications\n• Backend & AI development skills",
//         },
//       ]);

//       setShowInput(true);
//       setShowCloseConfirm(false);
//       setWindowState("default");
//       setHasNewReply(false);
//     } else {
//       setShowInput(false);
//       setInput("");
//       setLoading(false);
//       setShowCloseConfirm(false);
//       setWindowState("default");
//       setShowMinimizeNotification(false);
//     }
//   }, [open]);

//   /* ---------------- AUTO SCROLL ---------------- */

//   useEffect(() => {
//     chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [chat]);

//   /* ---------------- MODAL FOCUS ---------------- */

//   useEffect(() => {
//     if (showCloseConfirm && modalRef.current) {
//       modalRef.current.focus();
//     }
//   }, [showCloseConfirm]);

//   /* ---------------- MINIMIZE NOTIFICATION ---------------- */

//   useEffect(() => {
//     if (windowState === "minimized" && chat.some((msg) => msg.from === "user")) {
//       setShowMinimizeNotification(true);

//       const timer = setTimeout(() => setShowMinimizeNotification(false), 3000);

//       return () => clearTimeout(timer);
//     } else {
//       setShowMinimizeNotification(false);
//     }
//   }, [windowState, chat]);

//   /* ---------------- CHAT CONTROLS ---------------- */

//   const openChat = () => {
//     setOpen(true);
//     setHasNewReply(false);
//   };

//   const requestCloseChat = () => {
//     if (chat.length === 1 && chat[0].from === "bot") confirmClose();
//     else setShowCloseConfirm(true);
//   };

//   const cancelClose = () => setShowCloseConfirm(false);

//   const confirmClose = () => {
//     setOpen(false);
//     setChat([]);
//     setShowCloseConfirm(false);
//   };

//   const toggleWindowState = () => {
//     if (windowState === "minimized") setWindowState("default");
//     else if (windowState === "default") setWindowState("maximized");
//     else setWindowState("minimized");

//     setHasNewReply(false);
//   };

//   /* ---------------- API CALL ---------------- */

//   const sendQuestion = async (question) => {
//     if (!question.trim()) return;

//     setChat((prev) => [...prev, { from: "user", text: question }]);
//     setInput("");
//     setLoading(true);
//     setHasNewReply(false);

//     try {
//       const controller = new AbortController();
//       const timeout = setTimeout(() => controller.abort(), 15000);

//       const response = await fetch(
//         "https://portfolio-chatbot-1-7u5i.onrender.com/api/chatbot",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({ question }),
//           signal: controller.signal,
//         }
//       );

//       clearTimeout(timeout);

//       if (!response.ok) throw new Error("Server error");

//       const data = await response.json();

//       setChat((prev) => [
//         ...prev,
//         {
//           from: "bot",
//           text: data.reply || "Sorry, I couldn't find an answer.",
//         },
//       ]);

//       if (windowState === "minimized") setHasNewReply(true);
//     } catch (error) {
//       console.error("Chatbot API error:", error);

//       setChat((prev) => [
//         ...prev,
//         {
//           from: "bot",
//           text: "⚠️ Something went wrong connecting to the assistant.",
//         },
//       ]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ---------------- CLEAR CHAT ---------------- */

//   const handleClear = () => {
//     setChat([
//       {
//         from: "bot",
//         text: "👋 How can I assist you about Vinodh?",
//       },
//     ]);
//   };

//   /* ---------------- ENTER KEY ---------------- */

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !loading && input.trim()) {
//       e.preventDefault();
//       sendQuestion(input);
//     }
//   };

//   /* ---------------- UI ---------------- */

//   return (
//     <>
//       {/* Floating AI button */}

//       <button
//         onClick={open ? requestCloseChat : openChat}
//         className="fixed bottom-5 right-3 sm:bottom-6 sm:right-4 w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center text-2xl z-50 shadow-lg bg-gradient-to-br from-cyan-400 to-indigo-600"
//       >
//         🤖
//       </button>

//       {/* Chat Window */}

//       {open && (
//       <div
//         className={`fixed bg-gradient-to-br from-gray-900/80 to-gray-800/80 backdrop-blur-2xl text-white shadow-2xl border border-white/20 flex flex-col z-50
//         ${
//           windowState === "maximized"
//             ? "inset-2 rounded-2xl"
//             : "bottom-12 right-3 sm:right-4 w-[92vw] sm:w-[400px] h-[65vh] sm:h-[70vh] rounded-2xl"
//         }`}
//       >
//           {/* HEADER */}

//           <div className="p-3 border-b border-white/10 flex items-center justify-between bg-gradient-to-r from-cyan-900/50 to-indigo-900/50">

//         <span className="font-semibold text-sm sm:text-lg">
//           Vinodh Kumar • AI Assistant
//         </span>

//         <div className="flex items-center gap-3 text-lg">
//           <button
//             onClick={toggleWindowState}
//             className="hover:text-cyan-400 transition"
//           >
//             🗖
//           </button>

//           <button
//             onClick={requestCloseChat}
//             className="hover:text-red-400 transition"
//           >
//             ✕
//           </button>
//         </div>

//       </div>

//           {/* CONTACT BUTTON */}

//           <div className="p-3 border-b border-white/10">
//             <button
//               onClick={() =>
//                 window.open(
//                   "mailto:vinodhkumar142002@gmail.com"
//                 )
//               }
//               className="w-full bg-gradient-to-r from-cyan-500 to-indigo-500 rounded-lg px-4 py-2 font-semibold"
//             >
//               Contact Vinodh
//             </button>
//           </div>

//           {/* CHAT AREA */}

//           <div className="flex-1 p-3 space-y-3 overflow-y-auto">
//             {chat.map((msg, idx) => (
//               <div
//                 key={idx}
//                 className={`p-3 rounded-xl max-w-[80%] ${
//                   msg.from === "user"
//                     ? "bg-cyan-500/60 ml-auto"
//                     : "bg-gray-700/60"
//                 }`}
//               >
//                 {msg.from === "bot" ? "🤖 " : ""}
//                 {msg.text}
//               </div>
//             ))}

//             {loading && (
//               <div className="text-sm text-center animate-pulse">
//                 🤖 Thinking...
//               </div>
//             )}

//             <div ref={chatEndRef} />
//           </div>

//           {/* SUGGESTED QUESTIONS */}

//           {chat.length === 1 && (
//             <div className="px-3 pb-2 flex flex-wrap gap-2">
//               {[
//                 "What does Vinodh do at Deloitte?",
//                 "Tell me about Vinodh's cloud security experience",
//                 "What projects has Vinodh built?",
//                 "What certifications does Vinodh have?",
//               ].map((q, i) => (
//                 <button
//                   key={i}
//                   onClick={() => sendQuestion(q)}
//                   className="text-xs bg-gray-700 hover:bg-gray-600 px-3 py-1 rounded-full"
//                 >
//                   {q}
//                 </button>
//               ))}
//             </div>
//           )}

//           {/* INPUT */}

//           {showInput && (
//             <div className="p-2 border-t border-white/10 flex gap-2">
//               <input
//                 type="text"
//                 className="flex-1 rounded-lg px-3 py-2 bg-gray-800 text-white"
//                 placeholder="Ask about experience, projects, cloud security..."
//                 value={input}
//                 onChange={(e) => setInput(e.target.value)}
//                 onKeyDown={handleKeyDown}
//               />

//               <button
//                 onClick={() => sendQuestion(input)}
//                 className="bg-gradient-to-br from-cyan-500 to-indigo-500 px-4 py-2 rounded-lg"
//                 disabled={loading}
//               >
//                 Send
//               </button>
//             </div>
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default Chatbot;

import { useEffect, useState, useRef } from "react";

const Chatbot = () => {
  const [open, setOpen] = useState(false);
  const [chat, setChat] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [showInput, setShowInput] = useState(false);
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);
  const [windowState, setWindowState] = useState("default");
  const [showInitialNotification, setShowInitialNotification] = useState(false);
  const [showMinimizeNotification, setShowMinimizeNotification] = useState(false);
  const [hasNewReply, setHasNewReply] = useState(false);

  const modalRef = useRef(null);
  const chatEndRef = useRef(null);

  /* ---------------- INITIAL OPEN ANIMATION ---------------- */
  useEffect(() => {
    const notificationTimer = setTimeout(() => setShowInitialNotification(true), 2000);
    const openTimer = setTimeout(() => {
      setShowInitialNotification(false);
      setOpen(true);
    }, 3500);

    return () => {
      clearTimeout(notificationTimer);
      clearTimeout(openTimer);
    };
  }, []);

  /* ---------------- RESET CHAT ---------------- */
  useEffect(() => {
    if (open) {
      setChat([
        {
          from: "bot",
          text:
            "👋 Hi there! I'm Vinodh Kumar's AI assistant.\n\nYou can ask me about:\n• Cloud Security (AWS, Prisma Cloud)\n• Experience at Deloitte\n• Projects and Certifications\n• Backend & AI development skills",
        },
      ]);

      setShowInput(true);
      setShowCloseConfirm(false);
      setWindowState("default");
      setHasNewReply(false);
    } else {
      setShowInput(false);
      setInput("");
      setLoading(false);
      setShowCloseConfirm(false);
      setWindowState("default");
      setShowMinimizeNotification(false);
    }
  }, [open]);

  /* ---------------- AUTO SCROLL ---------------- */
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chat]);

  /* ---------------- MODAL FOCUS ---------------- */
  useEffect(() => {
    if (showCloseConfirm && modalRef.current) {
      modalRef.current.focus();
    }
  }, [showCloseConfirm]);

  /* ---------------- MINIMIZE NOTIFICATION ---------------- */
  useEffect(() => {
    if (windowState === "minimized" && chat.some((msg) => msg.from === "user")) {
      setShowMinimizeNotification(true);
      const timer = setTimeout(() => setShowMinimizeNotification(false), 3000);
      return () => clearTimeout(timer);
    } else {
      setShowMinimizeNotification(false);
    }
  }, [windowState, chat]);

  /* ---------------- CHAT CONTROLS ---------------- */
  const openChat = () => {
    setOpen(true);
    setHasNewReply(false);
  };

  const requestCloseChat = () => {
    if (chat.length === 1 && chat[0].from === "bot") confirmClose();
    else setShowCloseConfirm(true);
  };

  const cancelClose = () => setShowCloseConfirm(false);

  const confirmClose = () => {
    setOpen(false);
    setChat([]);
    setShowCloseConfirm(false);
  };

  const toggleWindowState = () => {
    if (windowState === "minimized") setWindowState("default");
    else if (windowState === "default") setWindowState("maximized");
    else setWindowState("minimized");

    setHasNewReply(false);
  };

  /* ---------------- API CALL ---------------- */
  const sendQuestion = async (question) => {
    if (!question.trim()) return;

    setChat((prev) => [...prev, { from: "user", text: question }]);
    setInput("");
    setLoading(true);
    setHasNewReply(false);

    try {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);

      const response = await fetch(
        "https://portfolio-chatbot-1-7u5i.onrender.com/api/chatbot",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ question }),
          signal: controller.signal,
        }
      );

      clearTimeout(timeout);

      if (!response.ok) throw new Error("Server error");

      const data = await response.json();

      setChat((prev) => [
        ...prev,
        {
          from: "bot",
          text: data.reply || "Sorry, I couldn't find an answer.",
        },
      ]);

      if (windowState === "minimized") setHasNewReply(true);
    } catch (error) {
      console.error("Chatbot API error:", error);

      setChat((prev) => [
        ...prev,
        {
          from: "bot",
          text: "⚠️ Something went wrong connecting to the assistant.",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- CLEAR CHAT ---------------- */
  const handleClear = () => {
    setChat([
      {
        from: "bot",
        text: "👋 How can I assist you about Vinodh?",
      },
    ]);
  };

  /* ---------------- ENTER KEY ---------------- */
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !loading && input.trim()) {
      e.preventDefault();
      sendQuestion(input);
    }
  };

  /* ---------------- UI ---------------- */
  return (
    <>
      {/* Floating AI button */}
      <button
        onClick={open ? requestCloseChat : openChat}
        className="fixed bottom-5 right-3 sm:bottom-6 sm:right-4 w-14 h-14 sm:w-16 sm:h-16 rounded-full flex items-center justify-center text-2xl z-50 shadow-lg bg-gradient-to-br from-cyan-400 to-indigo-600"
      >
        🤖
      </button>

      {/* Chat Window */}
      {open && (
        <div
          className={`fixed bg-gradient-to-br from-gray-900/80 to-gray-800/80 backdrop-blur-2xl text-white shadow-2xl border border-white/20 flex flex-col z-50
          ${
            windowState === "maximized"
              ? "inset-2 rounded-2xl"
              : "bottom-12 right-3 sm:right-4 w-[92vw] sm:w-[400px] h-[65vh] sm:h-[70vh] rounded-2xl"
          }`}
        >
          {/* HEADER */}
          <div className="p-3 border-b border-white/10 flex items-center justify-between bg-gradient-to-r from-cyan-900/50 to-indigo-900/50">
            <span className="font-semibold text-sm sm:text-lg">
              Vinodh Kumar • AI Assistant
            </span>

            <div className="flex items-center gap-3 text-lg">
              <button onClick={toggleWindowState} className="hover:text-cyan-400 transition">
                🗖
              </button>
              <button onClick={requestCloseChat} className="hover:text-red-400 transition">
                ✕
              </button>
            </div>
          </div>

          {/* CONTACT BUTTON */}
          <div className="p-3 border-b border-white/10">
            <button
              onClick={() => window.open("mailto:vinodhkumar142002@gmail.com")}
              className="w-full bg-gradient-to-r from-cyan-500 to-indigo-500 rounded-lg px-4 py-2 font-semibold"
            >
              Contact Vinodh
            </button>
          </div>

          {/* CHAT AREA */}
          <div className="flex-1 p-3 space-y-3 overflow-y-auto">
            {chat.map((msg, idx) => (
              <div
                key={idx}
                className={`p-3 rounded-xl max-w-[80%] ${
                  msg.from === "user" ? "bg-cyan-500/60 ml-auto" : "bg-gray-700/60"
                }`}
              >
                {msg.from === "bot" ? "🤖 " : ""}
                {msg.text}
              </div>
            ))}

            {loading && <div className="text-sm text-center animate-pulse">🤖 Thinking...</div>}
            <div ref={chatEndRef} />
          </div>

          {/* SUGGESTED QUESTIONS */}
          {chat.length === 1 && (
            <div className="px-3 pb-2 flex flex-wrap gap-2">
              {[
                "What does Vinodh do at Deloitte?",
                "Tell me about Vinodh's cloud security experience",
                "What projects has Vinodh built?",
                "What certifications does Vinodh have?",
              ].map((q, i) => (
                <button
                  key={i}
                  onClick={() => sendQuestion(q)}
                  className="text-xs bg-gray-700 hover:bg-gray-600 px-3 py-1 rounded-full"
                >
                  {q}
                </button>
              ))}
            </div>
          )}

          {/* INPUT */}
          {showInput && (
            <div className="p-2 border-t border-white/10 flex gap-2">
              <input
                type="text"
                className="flex-1 rounded-lg px-3 py-2 bg-gray-800 text-white"
                placeholder="Ask about experience, projects, cloud security..."
                value={input}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button
                onClick={() => sendQuestion(input)}
                className="bg-gradient-to-br from-cyan-500 to-indigo-500 px-4 py-2 rounded-lg"
                disabled={loading}
              >
                Send
              </button>
            </div>
          )}
        </div>
      )}

      {/* CLOSE CONFIRM MODAL */}
      {/* CLOSE CONFIRM MODAL */}
      {showCloseConfirm && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          tabIndex={-1}
          ref={modalRef}
        >
          <div className="bg-gray-900 p-5 rounded-xl text-white max-w-xs w-full">
            <p className="mb-4 text-center font-semibold">
              Are you sure you want to close the chat?
            </p>
            <div className="flex justify-center gap-4">
              <button
                onClick={confirmClose}
                className="px-4 py-2 rounded-lg bg-red-500 hover:bg-red-400"
              >
                Yes, Close
              </button>
              <button
                onClick={cancelClose}
                className="px-4 py-2 rounded-lg bg-gray-700 hover:bg-gray-600"
              >
                Keep Chat Open
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Chatbot;